module.exports = __webpack_public_path__ + "static/icon-kinvelly-d34272fa1db42b05d62aaf8a10299b8b.svg";